import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from "react-toastify";

const PublicRoute = ({ children }) => {
    const { isAuthenticated, isInitialAuthCheck } = useAuth();
    const location = useLocation();

    useEffect(() => {
        // Éviter les notifications lors du chargement initial
        if (!isInitialAuthCheck && isAuthenticated &&
            (location.pathname === '/login' || location.pathname === '/register')) {
            /*toast.info("Vous êtes déjà connecté. Déconnectez-vous pour accéder à cette page.", {
                toastId: 'already-connected'
            });*/
        }
    }, [isAuthenticated, isInitialAuthCheck, location.pathname]);

    // Bloquer la redirection pendant le chargement initial
    if (isInitialAuthCheck) {
        return null;
    }

    if (isAuthenticated) {
        return <Navigate to="/" replace state={{ from: location }} />;
    }

    return children;
};

export default PublicRoute;